// extracted by mini-css-extract-plugin
module.exports = {"title-area":"_3c6ef300a5--title-area--l8GH6","content-area":"_3c6ef300a5--content-area--nwI_r","action-area":"_3c6ef300a5--action-area--f01MQ"};